export default {"src":"/_next/static/media/play-icon.f74dd19a.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};